import { render, staticRenderFns } from "./medicalMark.vue?vue&type=template&id=12801d36&scoped=true&"
import script from "./medicalMark.vue?vue&type=script&lang=js&"
export * from "./medicalMark.vue?vue&type=script&lang=js&"
import style0 from "./medicalMark.vue?vue&type=style&index=0&id=12801d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12801d36",
  null
  
)

export default component.exports